if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"act-spa-cartera-common","remotes":[],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(297|308|486|775|884)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}